import React, { useEffect } from "react";
import { array, bool, object } from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import { StoryElementCard } from "../../../arrow/components/Molecules/StoryElementCard";
import { StoryTags } from "../../../arrow/components/Atoms/StoryTags";
import { Paywall } from "../../../arrow/components/Rows/Paywall";
import { LatestEditionMagazineBlock } from "../../molecules/LatestEditionMagazineBlock";
import AdComponent from "../../molecules/AdComponent";
import MoreAboutAuthors from "../../../arrow/components/Atoms/MoreAboutAuthors";
import { useDeviceType } from "../../customHooks/useDeviceType";
import "./story-elements.m.css";

const RenderCards = ({ story, cards, recommendedStories, taboola }) => {
  const qtState = useSelector((state) => state);
  const member = useSelector((state) => get(state, ["member"], null));
  const isMagazineStory = story["story-template"] === "magazine";
  //const isStoryBehindPaywall = !member && isMagazineStory;
  const isStoryBehindPaywall = false;
  const isDesktop = useDeviceType() === "desktop";
  const isAdfreePage = get(qtState, ["qt", "config", "subscriber"]) === "true";

  return (
    <div styleName="cards-wrapper">
      {isStoryBehindPaywall ? (
        <>
          <StoryElementCard
            story={story}
            card={cards[0]}
            key={get(cards[0], ["id"], "")}
            recommendedStories={recommendedStories}
            adComponent={(props) => (
              <AdComponent {...props} recommendedStories={recommendedStories} isDesktop={isDesktop} story={story} />
            )}
          />
          <Paywall magazine={true} />
        </>
      ) : (
        cards.map((card, index) => {
          return (
            <div key={index}>
              <StoryElementCard
                card={card}
                story={story}
                recommendedStories={recommendedStories}
                adComponent={(props) => (
                  <AdComponent {...props} recommendedStories={recommendedStories} isDesktop={isDesktop} story={story} />
                )}
              />
            </div>
          );
        })
      )}
      {!isAdfreePage && isStoryBehindPaywall ? null : (
        <>
          <StoryTags tags={story.tags} template="noBorder" story={story} />
          <MoreAboutAuthors authors={story.authors} story={story} />
          {taboola && (
            <>
              <div id="taboola-below-article-thumbnails" className="TABOOLA"></div>
              <div
                dangerouslySetInnerHTML={{
                  __html: `
                      <script type="text/javascript">
                        window._taboola = window._taboola || [];
                        _taboola.push({
                          mode: 'alternating-thumbnails-a',
                          container: 'taboola-below-article-thumbnails',
                          placement: 'Below Article Thumbnails',
                          target_type: 'mix'
                        });
                      </script>
                  `,
                }}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

RenderCards.propTypes = {
  story: object,
  cards: array,
  recommendedStories: array,
};

const StoryElements = ({
  story,
  cards,
  recommendedStories,
  config,
  isStickyBookReview = false,
  marginLeft = false,
}) => {
  const taboola = get(config, ["publisher-attributes", "taboola"], true);
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "300px 0px", // top margin of 300px
    threshold: 0.01, // when 10% is in view
  });

  useEffect(() => {
    if (inView && taboola === true) {
      // Initialize _taboola array if not already
      window._taboola = window._taboola || [];
      window._taboola.push({ article: "auto" });

      // Only insert script if not already present
      if (!document.getElementById("tb_loader_script")) {
        const s = document.createElement("script");
        s.async = true;
        s.src = "//cdn.taboola.com/libtrc/jambojar-fortuneindia/loader.js";
        s.id = "tb_loader_script";

        const f = document.getElementsByTagName("script")[0];
        f.parentNode.insertBefore(s, f);
      }

      // Optional: performance mark
      if (window.performance && typeof window.performance.mark === "function") {
        window.performance.mark("tbl_ic");
      }
    }
  }, [inView]);

  return (
    <div
      id="story-wrapper"
      styleName={`story-elements-wrapper ${isStickyBookReview ? "book-review-elements-wrapper" : ""} ${
        isStickyBookReview ? "review-elements-wrapper" : ""
      } ${marginLeft ? "marginLeft" : ""}`}
      ref={ref}
    >
      <RenderCards story={story} cards={cards} recommendedStories={recommendedStories} taboola={taboola} />
    </div>
  );
};

StoryElements.propTypes = {
  story: object,
  cards: array,
  recommendedStories: array,
  isStickyBookReview: bool,
  marginLeft: bool,
};

export default StoryElements;
